/* DDC motion layer: scroll reveal, ticker marquee, canvas hover/press, cart
   feedback, idle art. Progressive: nothing is hidden unless this script runs
   and finds it below the fold, and every failure path reveals everything. */
(function () {
  'use strict';
  var d = document, H = d.documentElement, W = window;
  if (!d.querySelector || !H.classList || !W.requestAnimationFrame || !W.getComputedStyle) return;
  var mm = function (q) { return W.matchMedia ? W.matchMedia(q) : { matches: false }; };
  var RM = mm('(prefers-reduced-motion: reduce)');
  var each = function (s, f, r) { Array.prototype.forEach.call((r || d).querySelectorAll(s), f); };
  var kids = function (el) { return Array.prototype.slice.call(el.children); };
  var onMQ = function (q, f) { if (q.addEventListener) q.addEventListener('change', f); else if (q.addListener) q.addListener(f); };
  var restart = function (el, c) { el.classList.remove(c); void el.offsetWidth; el.classList.add(c); };
  H.classList.add('ddc-m');

  /* ---- reveal on scroll ------------------------------------------------ */
  var units = [], alive = 0, raf = 0, iv = 0;

  function show(u, base) {
    u.els.forEach(function (o) {
      var el = o.el, ms = Math.round(base + o.lag);
      el.style.setProperty('--ddc-md', ms + 'ms');
      el.classList.add('ddc-m-in');
      el.classList.remove('ddc-m-wait');
      setTimeout(function () { el.classList.remove('ddc-m-in'); el.style.removeProperty('--ddc-md'); }, ms + 1000);
    });
  }
  function stop() {
    W.removeEventListener('scroll', onScroll, true);
    W.removeEventListener('resize', onScroll);
    clearInterval(iv);
  }
  function revealAll() {
    units.forEach(function (u) { u.els.forEach(function (o) { o.el.classList.remove('ddc-m-wait'); }); });
    units = []; stop();
  }
  function check() {
    raf = 0; alive = 1;
    try {
      var lim = (W.innerHeight || H.clientHeight) * 0.92, due = [], left = [];
      units.forEach(function (u) { var y = u.y(); if (y < lim) due.push([y, u]); else left.push(u); });
      units = left;
      due.sort(function (a, b) { return a[0] - b[0]; });
      due.forEach(function (a, i) { show(a[1], Math.min(i * 70, 420)); });
      if (!units.length) stop();
    } catch (e) { revealAll(); }
  }
  function onScroll() { if (!raf) raf = requestAnimationFrame(check); }

  function initCanvas(vh) {
    var all = d.querySelectorAll('.ddc-cv');
    each('.ddc-cv', function (cv) {
      var last = cv === all[all.length - 1], st = kids(cv).filter(function (s) { return s.offsetWidth && s.classList.contains('ddc-cv__stage'); })[0];
      if (!st) return;
      var cw = +st.getAttribute('data-cw') || 1440, ch = +st.getAttribute('data-ch') || 1;
      var rowH = cw > 800 ? 150 : 70, s = cv.clientWidth / cw, top0 = cv.getBoundingClientRect().top, rows = {};
      var list = [];
      kids(st).forEach(function (el) {
        if (el.classList.contains('ddc-cv__l')) list.push(el);
        else if (el.classList.contains('ddc-nl')) list = list.concat(kids(el));
      });
      list.forEach(function (el) {
        var t = el.offsetTop, r = Math.floor(Math.max(0, t) / rowH);
        if (top0 + t * s < vh) return; /* painted already: never hide it */
        var o = rows[r] || (rows[r] = { els: [], rt: r * rowH });
        /* Big grounds only fade; so does the page's last row, whose rise
           would briefly make the document taller. */
        if (el.offsetWidth * el.offsetHeight > cw * ch * 0.25 || (last && t + el.offsetHeight > ch - 40)) el.classList.add('ddc-m-big');
        o.els.push({ el: el, lag: (Math.max(0, t) - o.rt) / rowH * 140 });
      });
      Object.keys(rows).forEach(function (k) {
        var o = rows[k];
        o.y = function () { return cv.getBoundingClientRect().top + o.rt * cv.clientWidth / cw; };
        units.push(o);
      });
    });
  }
  function initPlain(vh) {
    var ITEMS = '.ddc-col__card,.ddc-rel__card,.ddc-search__card,.ddc-card,.ddc-pdpr__step,.ddc-facts__item,.ddc-cart__line';
    each('main .ddc-section', function (sec) {
      if (sec.closest('.ddc-cv')) return;
      var it = sec.querySelectorAll(ITEMS);
      (it.length ? Array.prototype.slice.call(it) : [sec]).forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < vh || !r.height || el._ddcU) return;
        el._ddcU = 1;
        units.push({ els: [{ el: el, lag: 0 }], y: function () { return el.getBoundingClientRect().top; } });
      });
    });
  }
  function initReveal() {
    if (RM.matches || !('IntersectionObserver' in W)) return;
    var vh = W.innerHeight || H.clientHeight;
    initCanvas(vh); initPlain(vh);
    if (!units.length) return;
    units.forEach(function (u) { u.els.forEach(function (o) { o.el.classList.add('ddc-m-wait'); }); });
    W.addEventListener('scroll', onScroll, { passive: true, capture: true });
    W.addEventListener('resize', onScroll);
    iv = setInterval(check, 1000); /* watchdog for missed scroll events (iOS) */
    setTimeout(function () { if (!alive) revealAll(); }, 2500);
    onMQ(mm('(max-width: 749px)'), revealAll);
    onMQ(RM, revealAll);
    W.addEventListener('pageshow', function (e) { if (e.persisted) revealAll(); });
    W.addEventListener('beforeprint', revealAll);
  }

  /* ---- ticker marquee ------------------------------------------------- */
  var mst, io = 'IntersectionObserver' in W ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { e.target.classList.toggle('ddc-m-off', !e.isIntersecting); });
  }) : null;

  function marquee(layer, i) {
    var sp = layer.firstElementChild, t = sp && sp.textContent || '', q = t.indexOf(t.slice(0, 16), 8);
    if (t.length < 40 || q < 8) return; /* only text that already repeats is a ticker */
    /* The visible run becomes an aria-hidden strip of the first phrase group
       repeated, sliding by exactly one group; the original span stays for
       screen readers. Copies in the comp differ by a space here and there, so
       repeating one group is what makes the loop point invisible. */
    var one = t.slice(0, q), name = 'ddc-mq' + i, c = sp.cloneNode(false), rule = d.createTextNode('');
    c.setAttribute('aria-hidden', 'true');
    c.className = 'ddc-m-mq';
    c.style.position = 'absolute';
    layer.appendChild(c);
    mst.appendChild(rule);
    /* Re-measured once web fonts are in: the fallback face is wider. */
    function fit() {
      c.textContent = one;
      var ha = layer.getAttribute('data-ha'), lw = parseFloat(layer.style.width) || layer.offsetWidth;
      var sw = parseFloat(getComputedStyle(sp).width), P = parseFloat(getComputedStyle(c).width);
      var fs = parseFloat(getComputedStyle(layer).fontSize) || 12;
      if (!(P > 20)) { c.textContent = ''; sp.style.opacity = ''; return; }
      c.style.top = sp.offsetTop + 'px';
      c.style.left = (ha === 'CENTER' ? (lw - sw) / 2 : ha === 'RIGHT' ? lw - sw : 0) + 'px';
      c.textContent = new Array(Math.ceil(lw / P) + 2).join(one);
      rule.data = '@keyframes ' + name + '{to{translate:-' + P.toFixed(3) + 'px 0}}';
      c.style.animation = name + ' ' + (P / (fs * 4)).toFixed(2) + 's linear infinite';
      sp.style.opacity = '0';
    }
    fit();
    if (d.fonts && d.fonts.ready) d.fonts.ready.then(fit);
    W.addEventListener('load', fit);
  }

  function initArt() {
    mst = d.head.appendChild(d.createElement('style'));
    if (!RM.matches) each('.ddc-cv__stage > .ddc-cv__t[data-nowrap]', function (l, i) {
      if (l.offsetWidth) marquee(l, i);
    });
    each('.ddc-cv__l > img', function (im, i) {
      var a = im.alt || '', l = im.parentNode, c = /^(leaves|drama mask)/i.test(a) ? 'ddc-m-sway' : /^shape neon/i.test(a) ? 'ddc-m-breathe' : '';
      if (c) { l.classList.add(c); l.style.animationDelay = (-i * 1.7) + 's'; }
    });
    each('.ddc-cv__l > svg [fill="rgb(216 252 0)"]', function (f) {
      var l = f.closest('.ddc-cv__l');
      if (l && parseFloat(l.style.width) > 150 && parseFloat(l.style.height) > 150 && !l.style.transform) l.classList.add('ddc-m-breathe');
    });
    if (io) each('.ddc-cv', function (cv) { io.observe(cv); });
  }

  /* ---- canvas hover / press ------------------------------------------- */
  function hot(t) { return t && t.closest ? t.closest('.ddc-hl, form.ddc-cv__l') : null; }
  function artFor(hs) {
    if (hs._ddcArt) return hs._ddcArt;
    var art = hs._ddcArt = [], st = hs.parentNode, cv = hs.closest('.ddc-cv'), id = cv ? cv.id : '';
    if (!st.classList.contains('ddc-cv__stage') || /^ddc-(pov|instagram)-/.test(id)) return art;
    var L = hs.offsetLeft, T = hs.offsetTop, w = hs.offsetWidth, h = hs.offsetHeight, A = w * h;
    var kind = hs.querySelector('.ddc-cv__cart') ? 'grow' : /^ddc-header-/.test(id) ? 'pop' :
      /^ddc-footer-/.test(id) ? 'nudge' : A > 20000 ? 'card' : 'lift';
    kids(st).forEach(function (el) {
      if (!el.classList.contains('ddc-cv__l')) return;
      var ew = el.offsetWidth, eh = el.offsetHeight, x = el.offsetLeft + ew / 2, y = el.offsetTop + eh / 2;
      if (el === hs || (x > L - 4 && x < L + w + 4 && y > T - 4 && y < T + h + 4 && ew * eh < A * 1.6)) {
        el.classList.add('ddc-m-art', 'ddc-m-' + kind);
        art.push(el);
      }
    });
    return art;
  }
  function flag(hs, c, on) { artFor(hs).forEach(function (el) { el.classList.toggle(c, on); }); }
  function initHover() {
    d.addEventListener('pointerover', function (e) {
      var hs = hot(e.target);
      if (hs && e.pointerType === 'mouse' && !hs.contains(e.relatedTarget)) flag(hs, 'ddc-m-hot', true);
    });
    d.addEventListener('pointerout', function (e) {
      var hs = hot(e.target);
      if (hs && !hs.contains(e.relatedTarget)) { flag(hs, 'ddc-m-hot', false); flag(hs, 'ddc-m-down', false); }
    });
    d.addEventListener('pointerdown', function (e) { var hs = hot(e.target); if (hs) flag(hs, 'ddc-m-down', true); });
    var up = function (e) { var hs = hot(e.target); if (hs) setTimeout(function () { flag(hs, 'ddc-m-down', false); }, 140); };
    d.addEventListener('pointerup', up);
    d.addEventListener('pointercancel', up);
    d.addEventListener('focusin', function (e) {
      var hs = hot(e.target), fv = true;
      try { fv = e.target.matches(':focus-visible'); } catch (x) {}
      if (hs && fv) flag(hs, 'ddc-m-hot', true);
    });
    d.addEventListener('focusout', function (e) { var hs = hot(e.target); if (hs) flag(hs, 'ddc-m-hot', false); });
  }

  /* ---- add-to-cart feedback ------------------------------------------- */
  var KEY = 'ddc-m-added', of = W.fetch;
  function bump() { each('.ddc-hl__badge', function (b) { restart(b, 'ddc-m-bump'); }); }
  function refresh() {
    of.call(W, '/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      each('.ddc-hl__badge', function (b) {
        b.textContent = c.item_count;
        var a = b.parentNode, lab = a.getAttribute('aria-label') || '';
        if (/^Cart,/.test(lab)) a.setAttribute('aria-label', 'Cart, ' + c.item_count + ' items');
      });
      bump();
    }, bump);
  }
  function initCart() {
    d.addEventListener('submit', function (e) {
      var f = e.target, b;
      if (!f || !/\/cart\/add/.test(f.getAttribute('action') || '')) return;
      if (f.matches('.ddc-hl, form.ddc-cv__l')) artFor(f).forEach(function (el) { restart(el, 'ddc-m-sent'); });
      else if ((b = e.submitter || f.querySelector('[type=submit]'))) restart(b, 'ddc-m-sent');
      try { sessionStorage.setItem(KEY, Date.now()); } catch (x) {}
    });
    try {
      var ts = +sessionStorage.getItem(KEY);
      if (ts) { sessionStorage.removeItem(KEY); if (Date.now() - ts < 20000) setTimeout(bump, 400); }
    } catch (x) {}
    if (of) W.fetch = function (input) {
      var p = of.apply(W, arguments);
      try {
        if (/\/cart\/add/.test(input && input.url || String(input))) p.then(function (r) {
          if (!r.ok) return;
          try { sessionStorage.removeItem(KEY); } catch (x) {}
          refresh();
        }, function () {});
      } catch (x) {}
      return p;
    };
    if (W.MutationObserver) each('.ddc-price [data-now]', function (el) {
      new MutationObserver(function () { restart(el, 'ddc-m-tick'); }).observe(el, { childList: true, characterData: true, subtree: true });
    });
  }

  [initReveal, initArt, initHover, initCart].forEach(function (f) {
    try { f(); } catch (e) { if (f === initReveal) revealAll(); }
  });
})();
